// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-rider-strip {
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 0.5rem;
}

.modal-rider-strip--single {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
}

.modal-rider-select {
  max-width: 280px;
  font-weight: 600;
  font-size: 0.875rem;
  color: #111827;
  border-color: #d1d5db;
  background-color: #f9fafb;
}
.modal-rider-select:focus {
  border-color: var(--sms-blue, #346498);
  box-shadow: 0 0 0 2px rgba(52, 100, 152, 0.12);
}

.modal-rider-hint {
  font-size: 0.72rem;
  color: #9ca3af;
  margin-top: 0.35rem;
  margin-bottom: 0;
}

.modal-rider-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
}

/* ── Filter bar ── */

.modal-filter-bar {
  margin-bottom: 0.5rem;
}

.modal-list-meta {
  font-size: 0.72rem;
  color: #9ca3af;
  margin-top: 0.35rem;
  padding-left: 0.1rem;
}

.modal-list-meta__selected {
  color: var(--sms-blue, #346498);
  font-weight: 600;
}

/* ── Scrollable list ── */

.modal-list {
  max-height: 55vh;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
}

/* ── List items ── */

.modal-list-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0.75rem;
  cursor: default;
  transition: background 0.1s;
}

.modal-list-item:focus {
  outline: 2px solid var(--sms-blue, #346498);
  outline-offset: -2px;
}

.modal-list-item--selected {
  background: #eff6ff;
}

.modal-item-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
  color: #111827;
}

.modal-check-icon {
  color: #16a34a;
}

/* ── Empty state ── */

.modal-empty-state {
  font-size: 0.8rem;
  color: #9ca3af;
  font-style: italic;
  text-align: center;
  padding: 1.25rem 1rem;
}

/* ── Footer ── */

.modal-footer--with-hint {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.modal-done-hint {
  font-size: 0.72rem;
  color: #9ca3af;
}

@media (max-width: 576px) {
  .modal-footer--with-hint {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }
  .modal-done-hint { text-align: center; }
  .modal-list { max-height: 45vh; }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-choose-section/modal-choose-section.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;EACA,mBAAmB,kBAAkB,EAAE;EACvC,cAAc,gBAAgB,EAAE;AAClC","sourcesContent":[".modal-rider-strip {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #f3f4f6;\n  margin-bottom: 0.5rem;\n}\n\n.modal-rider-strip--single {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n}\n\n.modal-rider-select {\n  max-width: 280px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #111827;\n  border-color: #d1d5db;\n  background-color: #f9fafb;\n}\n.modal-rider-select:focus {\n  border-color: var(--sms-blue, #346498);\n  box-shadow: 0 0 0 2px rgba(52, 100, 152, 0.12);\n}\n\n.modal-rider-hint {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  margin-top: 0.35rem;\n  margin-bottom: 0;\n}\n\n.modal-rider-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n/* ── Filter bar ── */\n\n.modal-filter-bar {\n  margin-bottom: 0.5rem;\n}\n\n.modal-list-meta {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  margin-top: 0.35rem;\n  padding-left: 0.1rem;\n}\n\n.modal-list-meta__selected {\n  color: var(--sms-blue, #346498);\n  font-weight: 600;\n}\n\n/* ── Scrollable list ── */\n\n.modal-list {\n  max-height: 55vh;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n}\n\n/* ── List items ── */\n\n.modal-list-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.55rem 0.75rem;\n  cursor: default;\n  transition: background 0.1s;\n}\n\n.modal-list-item:focus {\n  outline: 2px solid var(--sms-blue, #346498);\n  outline-offset: -2px;\n}\n\n.modal-list-item--selected {\n  background: #eff6ff;\n}\n\n.modal-item-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  color: #111827;\n}\n\n.modal-check-icon {\n  color: #16a34a;\n}\n\n/* ── Empty state ── */\n\n.modal-empty-state {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  font-style: italic;\n  text-align: center;\n  padding: 1.25rem 1rem;\n}\n\n/* ── Footer ── */\n\n.modal-footer--with-hint {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.modal-done-hint {\n  font-size: 0.72rem;\n  color: #9ca3af;\n}\n\n@media (max-width: 576px) {\n  .modal-footer--with-hint {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n  }\n  .modal-done-hint { text-align: center; }\n  .modal-list { max-height: 45vh; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
